import getCommonTestId from 'constants/testsIds/common';
import { withErrorBoundary } from 'components/ErrorBoundary';
import { UIFragments } from 'utils/log/constants/uiFragments';
import PinnedSubsectionCard, { type PinnedSubsectionCardProps } from './PinnedSubsectionCard';
import * as S from './PinnedSubsectionCardStyles';

export type PinnedSubsectionCardListProps = {
  subsections: PinnedSubsectionCardProps[];
};

const PinnedSubsectionCardList = ({ subsections }: PinnedSubsectionCardListProps) => {
  if (!subsections || subsections.length === 0) return null;
  return (
    <S.PinnedSubsectionCardList
      data-cy={getCommonTestId('PINNED_SUBSECTIONS_LIST')}
      $noOfCards={subsections.length}
    >
      {subsections.map(({ label, url, icon }) => (
        <PinnedSubsectionCard
          key={url}
          label={label}
          url={url}
          icon={icon}
        />
      ))}
    </S.PinnedSubsectionCardList>
  );
};

export default withErrorBoundary(PinnedSubsectionCardList, { fragment: UIFragments.PINNED_SUBSECTION_CARD_LIST });
